import React from 'react';

import ApprovedRequestsTable from './ApprovedRequestsTable';
import CancelRequestModal from './CancelRequestModal';
import EditDurationModal from './EditDurationModal';
import styles from './CoursePauseApprovedPage.module.scss';
import ViewLectureModal from './ViewLectureModal';

function CoursePauseApprovedPage() {
  return (
    <div className={styles.root}>
      <CancelRequestModal />
      <EditDurationModal />
      <ViewLectureModal />
      <ApprovedRequestsTable />
    </div>
  );
}

export default CoursePauseApprovedPage;
